import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import { ProductType } from '../../interfaces/ProductProperties/ProductPropertiesRelated';
import MultiTestEndPagePageProps from './MultiTestEndPagePage.props';
import MultiTestEndPagePageState from './MultiTestEndPagePage.state';
import BannerWithLink from '../../components/BannerWithLink/BannerWithLink';
import { LocalStorageItems } from '../../services/LocalStorageProvider/LocalStorageProvider.props';
import { EHeaderShopCampaignData } from '../../interfaces/HeaderShopCampaign/EHeaderShopCampaign';
import HeaderShopCampaign from '../../components/HeaderShopCampaign/HeaderShopCampaign';
import track from 'react-tracking';
import { TrackingVariantETracker } from '../../interfaces/Tracking/TrackingVariantETracker';
import TrackingMeta from '../../interfaces/Tracking/TrackingMeta';

@track({ /*page: UrlPaths.MULTITESTENDPAGE*/ })
export default class MultiTestEndPagePage extends Component<MultiTestEndPagePageProps, MultiTestEndPagePageState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    private step: string;


    constructor(props: MultiTestEndPagePageProps) {
        super(props);
        this.state = { 
            key: 'value',
            pageDetails: {
                campaignId: this.props.pageDetails.campaignId,
                pageType: this.props.pageDetails.pageType
            }
        };

        this.step = 'step3'
    }

    componentDidMount(): void {
        window.scrollTo(0, 0);
        this.init();

        this.trackStep();
    }

    componentDidUpdate(prevProps: Readonly<MultiTestEndPagePageProps>, prevState: Readonly<MultiTestEndPagePageState>, snapshot?: any): void {
        this.switchContentToBeDisplayedAndRemoveCampaignCartFromLS();
    }

    init() {
        this.switchContentToBeDisplayedAndRemoveCampaignCartFromLS();
    }

    // Tracking step with eTracker 
    trackStep() {
        if (!this.state.pageDetails || !this.state.pageDetails.campaignId || !this.state.pageDetails.pageType) return;
        if (!this.context.sessionStorageProvider.getCounterForSteps(this.state.pageDetails.campaignId, this.state.pageDetails.pageType, this.step)) {
            this.context.sessionStorageProvider.setCounterForSteps(this.state.pageDetails.campaignId, this.state.pageDetails.pageType, this.step);
            this.trackStepHandler();
        }
    }

    @track((props: MultiTestEndPagePageProps, state: MultiTestEndPagePageState) => ({
        trackingMeta: {
            variant: TrackingVariantETracker.WATCHSTEP
        } as TrackingMeta,
        pageType: state.pageDetails.pageType,
        campaignId: state.pageDetails.campaignId,
        step: 'step3'
    }))
    trackStepHandler() {
        return;
    }

    switchContentToBeDisplayedAndRemoveCampaignCartFromLS() {
        const selectionPage = document.getElementById('step1page') as HTMLDivElement;
        const formPage = document.getElementById('step2page') as HTMLDivElement;

        if (formPage && selectionPage) {
            // window.location.reload();
            selectionPage.style.display = 'none';
            formPage.style.display = 'block';
        }

        setTimeout(() => {
            sessionStorage.removeItem(`${this.state.pageDetails.pageType}_${this.state.pageDetails.campaignId}_${LocalStorageItems.CART}`)
        }, 5000)
    }

    render(): React.ReactNode {
        return (
            <>
                <HeaderShopCampaign pathForContent={`${EHeaderShopCampaignData.ENDPAGEPATH}.${this.props.pageDetails.pageType}.header`} pageDetails={this.props.pageDetails} />
                <section className="cs-end-page content-section in-viewport">
                    <div className="container">

                        <div className="end-page">
                            
                            <div className="textblock">
                                <h2 className="end-page__subtitle">{this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.subtitle`)}</h2>
                            </div>
                            <div className={'end-page__next-steps'}>
                                <div className="end-page__next-steps-row row">
                                    {
                                        this.context.utilityProvider.orderWithNewRegistration(this.context.sessionStorageProvider.getCustomerDataFromSessionStorage()) 
                                            && !this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            && (
                                                this.context.utilityProvider.orderHasTestproduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                || this.context.utilityProvider.orderHasPOB(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            )
                                            ? <div className="col end-page__col end-page__col--a">
                                                <h3 className="end-page__next-steps-title">
                                                    {this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.a.title`)}
                                                </h3>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.a.text`)
                                                        ?.replaceAll('{{email}}', this.context.sessionStorageProvider.getCustomerDataFromSessionStorage().email as string) as string
                                                }}></div>
                                            </div>
                                            : undefined
                                    }
                                    <div className="col end-page__col end-page__col--b">
                                        <h3 className="end-page__next-steps-title">
                                            {this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.title`)}
                                        </h3>
                                        <div className="textblock" dangerouslySetInnerHTML={{
                                            __html: this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.text`)
                                                ?.replaceAll(
                                                    '{{notloggedin}}', 
                                                    this.context.utilityProvider.orderWithNewRegistration(this.context.sessionStorageProvider.getCustomerDataFromSessionStorage())
                                                        ? this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.replacement.notLoggedIn`) as string
                                                        : ''
                                                )
                                                .replaceAll(
                                                    '{{producttypes}}', 
                                                    this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || []) 
                                                        ? this.context.utilityProvider.orderHasTestproduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                            ? this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.replacement.productTypes.buyAndTestProduct`) as string
                                                            : this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.replacement.productTypes.buyProduct`) as string
                                                        : this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.b.replacement.productTypes.testProduct`) as string
                                                ) as string
                                        }}></div>
                                    </div>
                                    {
                                        this.context.utilityProvider.orderHasBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            && this.context.utilityProvider.orderHasMoreThanOneUser(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                            ? <div className="col end-page__col end-page__col--c">
                                                <h3 className="end-page__next-steps-title">
                                                    {this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.c.title`)}
                                                </h3>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.c.text`)
                                                        ?.replaceAll(
                                                            '{{perproduct}}', 
                                                            this.context.utilityProvider.orderHasMoreThanOneBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                                ? this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.c.replacement.perProduct`) as string
                                                                : ''
                                                        )
                                                        .replaceAll(
                                                            '{{morethanonelicense}}', 
                                                            this.context.utilityProvider.orderHasMoreThanOneBuyableProduct(this.context.sessionStorageProvider.getProductInformationFromSessionStorage()?.warenkorbData || [])
                                                                ? this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.nextSteps.c.replacement.moreThanOneLicense`) as string
                                                                : ''
                                                        ) as string
                                                }}></div>
                                            </div>
                                            : undefined
                                    }
                                </div>
                            </div>
                            <div className="end-page__next-steps">
                                <div className="end-page__next-steps-generic">
                                    <div className="textblock" dangerouslySetInnerHTML={{
                                        __html: this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.genericText`) || ''
                                    }}></div>
                                </div>
                            </div>
                            <div className="end-page__footer">
                                <div className="textblock" dangerouslySetInnerHTML={{
                                    __html: this.context.i18nProvider.get(`endPageCampaignOrder.${this.state.pageDetails.pageType}.footerText`) || ''
                                }}></div>
                            </div>

                            <div className="end-page__products">
                                <div className="product-teaser">
                                    <h2 className="sr-only">Bestellte Produkte</h2>
                                    <div className="product-teaser__slider row">
                                        {
                                            this.context.sessionStorageProvider.getProductInformationFromSessionStorageCampaign()?.warenkorbData
                                                .sort((productA, productB) => {
                                                    if (productA.productType === ProductType.TEST) {
                                                        if (productB.productType === ProductType.TEST) {
                                                            return 0;
                                                        } else {
                                                            return 1;
                                                        }
                                                    } else {
                                                        if (productB.productType === ProductType.TEST) {
                                                            return -1;
                                                        } else {
                                                            return 0;
                                                        }
                                                    }
                                                })
                                                .filter( (product) => product.queryInformation.title !== '')
                                                .map((product, index) => {
                                                    return <div className="product-teaser__col col-6 col-md-3 col-lg-2" key={index}>
                                                        <div className="product-card product-card--shadow">
                                                            <div className="product-card__image-container">
                                                                <div className="product-card__image-overlay-wrapper">
                                                                    <img className="product-card__image" 
                                                                        src={product.queryInformation.imageSrc} 
                                                                        alt={product.queryInformation.imageAlt} />
                                                                </div>
                                                            </div>

                                                            <div className="product-card__text">
                                                                <span className="product-card__title" dangerouslySetInnerHTML={{
                                                                    __html: (product.productType === ProductType.TEST && !this.context.globalStates.getDiscountStatusFromProductProperties(product)
                                                                        ? this.context.i18nProvider.get('endPage.titlePrefixForTestProduct') 
                                                                        : (product.productType === ProductType.TEST && this.context.globalStates.getDiscountStatusFromProductProperties(product) 
                                                                            ? this.context.i18nProvider.get('endPage.titlePrefixForTestProductDiscount') 
                                                                            : '')) + product.queryInformation.title
                                                                }}></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                        }
                                    </div>
                                    <div className="product-teaser__arrows">
                                        <div className="product-teaser__arrow-prev"></div>
                                        <div className="product-teaser__arrow-next"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                { this.context.i18nProvider.get('bannerWithLink.title') !== '' &&
                    <BannerWithLink pageDetails={this.props.pageDetails}/>
                }
                <section className="cs-cta-button-group content-section">
                    <div className="container">

                        <div className="cta-button-group">
                            <div className="cta-button-group__cta-wrapper--button"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        (this.context.i18nProvider.get(
                                            'endPage.buttons',
                                            { returnObjects: true }
                                        ) as unknown as Array<string>).join()
                                }}></div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
